export const AUDIO_ELEMENT_ID = 'n2p-web-dialer-remote-audio'
export const TRANSFER = 'TRANSFER'
export const DIALPAD = 'DIALPAD'
export const ADD_CALL = 'ADD_CALL'
export const HOLD_CALL = 'HOLD_CALL'
export const PARK_CALL = 'PARK_CALL'
export const MUTE = 'MUTE'
export const UNMUTE = 'UNMUTE'
export const BLOCK_NUMBER = 'BLOCK_NUMBER'
export const END_CALL = 'END_CALL'
export const ACTIONS = [ADD_CALL, DIALPAD, TRANSFER, false]
export const SECOND = 1000
export const MINUTE = 60 * SECOND
export const MAX_LIST_SIZE = 30
export const DIALER_MODE = {
  STANDARD: 'standard',
}
export const ACTIVE_CALL_TRANSFER_KEY = 'ACTIVE_CALL_TRANSFER_KEY'

export const DEV_MOUNT_POINT = document.querySelector<HTMLDivElement>(
  '.n2p-dialer-mount-point',
)

export const DEFAULT_LOCALE = 'en'
